module.exports = ".dropdown-menu {\r\n  max-height: 250px;\r\n}\r\n\r\n.ownLoader {\r\n  position: relative;\r\n  z-index: 1011;\r\n  font-size: 34px;\r\n  color: blue;\r\n  bottom: 31px;\r\n  left: 84%;\r\n}\r\n\r\n.outerBox {\r\n  position: relative;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-drop-down/data-drop-down.component.css
// module id = ./src/app/components/data-drop-down/data-drop-down.component.css
// module chunks = main